let auth_token = '';

async function send(request, query) {
  let response;

  try {
    response = await fetch(request.url + auth_token, query);
  } catch (e) {
    // eslint-disable-next-line
    throw 'SERVER_NOT_WORKING';
  }

  if (response.status < 200 || response.status > 300) {
    // eslint-disable-next-line
    throw 'UNEXPECTED_SERVER_ERROR';
  }
  let data = await parseJSON(response);

  if (data && data.error) {
    throw data.error_message;
  }

  return data;
}

async function parseJSON(response) {
  try {
    let data = response && (await response.json());
    return data;
  } catch (e) {
    return null;
  }
}

const buildQuery = (method, request) => {
  return {
    method,
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify(request.params)
  };
};

export const setAjaxToken = token => (auth_token = `?token=${token}`);
export const get = send;
export const remove = request => send(request, buildQuery('DELETE', request));
export const post = request => send(request, buildQuery('POST', request));
export const put = request => send(request, buildQuery('PUT', request));



// WEBPACK FOOTER //
// ./src/utils/crud.js